<!-- NotificationItem.svelte -->
<script lang="ts">
  export let customClass = "";
  export let onClicked: (id: string) => void;
</script>

<button
  on:click={() => onClicked("id-goes-here")}
  class="flex items-center space-x-4 text-left {customClass} hover:bg-[#E3F2F3] px-[16px]"
>
  <!-- Gray Circle -->
  <img
    class="min-w-[48px]"
    src="/icons/menu-notification.svg"
    alt="notification"
  />

  <!-- Text Section -->
  <div class="flex-grow">
    <p class="text-[16px] font-bold text-gray-800">
      Park46-import av Westerlunden har slutförts.
    </p>
    <p class="text-gray-500 text-[14px] font-bold">55 min</p>
  </div>

  <!-- Red Dot -->
  <div>
    <div class="w-[12px] h-[12px] bg-red-5 rounded-full"></div>
  </div>
</button>
